import * as ActionTypes from './ActionTypes';
import initialState from './InitialState';
import { assign } from '../../shared/Assign';

export default function planTemplateReducer(
    state: any = initialState.planTemplates,
    action: { type: string; result: any }
): any {
    switch (action.type) {
        case ActionTypes.CREATE_PLAN_TEMPLATE_SUCCESS: {
            const newState = assign({}, state);
            newState.create = assign({}, state.create);
            if (action.result.hasOwnProperty('imageReferences')) {
                newState.list = [...state.list, assign({}, action.result)];
            }
            newState.create.planTemplate = action.result;
            return newState;
        }

        case ActionTypes.UPLOAD_FILES_TEMPLATE_SUCCESS: {
            const newState = assign({}, state);
            newState.create = assign({}, state.create);
            newState.create.planTemplate = assign({}, state.create.planTemplate);
            newState.create.planTemplate.imageReferences = action.result;
            newState.list = [...state.list, assign({}, newState.create.planTemplate)];
            newState.create.imageReferences = action.result;
            return newState;
        }

        case ActionTypes.DELETE_PLAN_TEMPLATE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list.filter((x: any) => x.id !== action.result)];
            return newState;
        }

        case ActionTypes.CLEAR_PLAN_TEMPLATE_STATE: {
            const newState = assign({}, state);
            newState.create = assign({}, state.create);
            newState.create.planTemplate = {};
            return newState;
        }

        case ActionTypes.UPDATE_PLAN_TEMPLATE_SUCCESS: {
            const newState = assign({}, state);
            if (!action.result.hasOwnProperty('imageReferences')) {
                let listItem = newState.list.find((x: any) => x.id === action.result.id);
                action.result.imageReferences = listItem.imageReferences;
            }

            let item = newState.list.find((x) => x.id === action.result.id);
            item.name = action.result.name;
            item.planGenerationTemplate = action.result.planGenerationTemplate;
            item.isAutoGenerationActive = action.result.isAutoGenerationActive;
            item.imageReferences = action.result.imageReferences;
            return newState;
        }

        case ActionTypes.LIST_PLAN_TEMPLATE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result.planTemplates;
            newState.availablePlanGenerationTemplates =
                action.result.availablePlanGenerationTemplates;
            return newState;
        }

        default:
            return state;
    }
}
